import sortBy from 'lodash/sortBy'
import {fromJust, fromMaybe} from '@freckle/maybe'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import {
  getFormattedFirstName,
  formattedName,
} from '@freckle/educator-entities/ts/users/models/student'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {studentDropdown} from './student-picker.module.scss'

type Props = {
  students: Array<StudentAttrs>
  currentStudentId: number | undefined | null
  onChangeStudent: (teacherId?: number | null) => void
}

export function StudentPicker(props: Props) {
  const {students, currentStudentId, onChangeStudent} = props
  const {t} = useSafeTranslation()

  const showingAllStudents = currentStudentId === null || currentStudentId === undefined

  const currentStudent = fromMaybe(
    () => fromJust(students[0], 'Could not set a current student in student picker'),
    students.find(student => student.id === currentStudentId),
  )

  const sortedStudents = sortBy(students, student => student.lastName)

  const studentItems = sortedStudents.map(student => ({
    label: formattedName(student),
    value: student.id.toString(),
  }))

  const allStudentsOption = {label: t('STUDENT_PICKER_MENU_ITEM_ALL'), value: 'AllStudents'}

  const menuItems = [allStudentsOption, ...studentItems]

  const value = showingAllStudents
    ? allStudentsOption
    : {label: getFormattedFirstName(currentStudent), value: currentStudentId.toString()}

  return (
    <div className={studentDropdown} id="student-picker-dropdown">
      <div data-pii>
        <Dropdown<string | undefined>
          labelText={t('STUDENT_PICKER_LABEL')}
          options={flatOptions(menuItems)}
          value={value}
          handleChange={input => {
            if (input === null) return
            onChangeStudent(
              input.value === 'AllStudents' ? null : parseInt(input.value as string, 10),
            )
          }}
        />
      </div>
    </div>
  )
}
